import AttributeDeletionModal from '../../Modals/AttributeModals/AttributeDeletionModal'
import CircuitDeletionModal from '../../Modals/CircuitModals/CircuitDeletionModal'
import DeleteContentCategoryModal from '../../Modals/ContentModals/DeleteContentCategoryModal'
import DeleteGroupForm from '../../Modals/DeviceModals/DeleteGroupForm'
import DeleteShadowFrom from '../../Modals/DeviceModals/DeleteShadowFrom'
import DeleteTypeForm from '../../Modals/DeviceModals/DeleteTypeForm'
import DeleteUserForm from '../../Modals/DeviceModals/DeleteUserForm'
import DeleteExperimentCategoryModal from '../../Modals/ExperimentModals/DeleteExperimentCategoryModal'
import DeleteExperimentTypeModal from '../../Modals/ExperimentModals/DeleteExperimentTypeModal'

function DeleteTabContentModal({checkList, deletionProcess, item, setAction}: any) {
  if (deletionProcess === 'Type') {
    return <DeleteTypeForm checkList={checkList} itemId={item.id} setAction={setAction} />
  } else if (deletionProcess === 'Group') {
    return <DeleteGroupForm checkList={checkList} itemId={item.id} setAction={setAction} />
  } else if (deletionProcess === 'User') {
    return <DeleteUserForm checkList={checkList} itemId={item.id} setAction={setAction} />
  } else if (deletionProcess === 'Shadow') {
    return <DeleteShadowFrom checkList={checkList} setAction={setAction} />
  } else if (deletionProcess === 'Circuit') {
    return <CircuitDeletionModal checkList={checkList} setAction={setAction} />
  } else if (deletionProcess === 'ECategory') {
    return <DeleteExperimentCategoryModal checkList={checkList} setAction={setAction} />
  } else if (deletionProcess === 'EType') {
    return <DeleteExperimentTypeModal checkList={checkList} setAction={setAction} />
  } else if (deletionProcess === 'Attribute') {
    return <AttributeDeletionModal checkList={checkList} setAction={setAction} />
  } else if (deletionProcess === 'Category') {
    return <DeleteContentCategoryModal checkList={checkList} setAction={setAction} />
  } /* else if (deletionProcess === 'Message') {
    return (
      <DeleteTopicMessageModal
        checkList={checkList}
        setAction={setAction}
        SuccessfulNotify={SuccessfulNotify}
        UnsuccessfulNotify={UnsuccessfulNotify}
      />
    )
  }*/
  return <div></div>
}

export default DeleteTabContentModal
